export const globalStyles = `
  :root {
    --neon-cyan: #00f2ff;
    --neon-cyan-dim: rgba(0,242,255,0.15);
    --pen-blue: #01315b;
    --deep-blue: #020b16;
    --mid-blue: #041e36;
    --border-glow: rgba(0,242,255,0.25);
    --accent-green: #3dfcad;
    --accent-green-dim: rgba(61,252,173,0.15);
    --gold: #f5c518;
    --text-muted: rgba(255,255,255,0.55);
  }
  @keyframes spin { to { transform: rotate(360deg); } }
`;
